import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">
              {t('common.siteTitle')}
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              {t('common.footerTagline')}
            </p>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold text-background-100 mb-4">
              {t('common.navCategories')}
            </h5>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold text-background-100 mb-4">
              快速链接
            </h5>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  {t('common.navHome')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  {t('common.navAbout')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold text-background-100 mb-4">
              {t('common.navContact')}
            </h5>
            <p className="text-sm text-background-400 leading-relaxed">
              邮箱：hello@family-guide.com
            </p>
            <p className="text-sm text-background-400 mt-1">
              关注我们的社交媒体
            </p>
            <div className="flex gap-4 mt-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer" rel="nofollow" aria-label="小红书">
                <i className="ri-chat-smile-2-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">{t('common.footerCopyright')}</p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}